import { useContext } from 'react';

import { CircleContext } from '@/lib/circle/CircleContext';
import type { CircleContextValue } from '@/lib/circle/CircleContext';

export function useCircle(): CircleContextValue {
  const ctx = useContext(CircleContext);
  if (!ctx) throw new Error('useCircle must be used within CircleProvider');
  return ctx;
}
